import { LanguageCodeEnum as e } from "@systemeio/types";
//#region src/date-time/date-time-format.ts
var t = (t, n) => new Date(new Intl.DateTimeFormat(e.ENGLISH, {
	timeZone: n,
	month: "2-digit",
	day: "2-digit",
	year: "numeric",
	hour: "numeric",
	minute: "numeric",
	second: "numeric"
}).format(t)), n = (e, t) => {
	if (!t && !e) return "";
	let n = new Intl.DateTimeFormat(e, {
		timeZone: t,
		timeZoneName: "shortOffset"
	}).formatToParts(/* @__PURE__ */ new Date()).find((e) => e.type === "timeZoneName");
	if (n) return n.value.replace("GMT", "UTC");
};
//#endregion
export { n as getFormattedUtcOffset, t as getTimezoneDate };
